import _ from 'lodash';

// constants
import LocalStrings from '../../../assets/languages';
import { showError, showSuccess } from '../../Common/alertmessage';
import { TABLE_URI_ADDON } from '../../../constants/constant';
import {
  FETCH_ORDERS,
  FIELDS,
  TABLES
} from '../../../constants/section-constants/eventify-constant';
import {
  deleteRequest,
  getRequest,
  patchRequest,
  postRequest
} from '../../Common/network-call';

// actions
import { activateNavbarLineLoader } from '../../../actions';

export const APPUSER_ACTIVITIES = 'APPUSER_ACTIVITIES';
export const ACTIVITY_FORM_RENDER = 'ACTIVITY_FORM_RENDER';

export const fetchAppuserActivity = (session, callback = null) => {
  const fetchFilter = encodeURI(
    `((eventid=${session.eventid})AND(appuserid=${session.userid})AND(isdeleted=0))`
  );
  const fetchUrl = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.appuserActivity}?include_count=true&fields=${FIELDS.appuserActivity.mediumInfo}&filter=${fetchFilter}&order=${FETCH_ORDERS.activity}`;

  return dispatch => {
    dispatch(activateNavbarLineLoader(true));
    getRequest(
      fetchUrl,
      session,
      dispatch,
      res => {
        dispatch(activateNavbarLineLoader(false));
        const payloadVal = {
          resource: res?.resource,
          count: res?.meta?.count
        };
        dispatch({ type: APPUSER_ACTIVITIES, payload: payloadVal });
        callback && callback({ success: 1, data: payloadVal, error: null });
      },
      error => {
        dispatch(activateNavbarLineLoader(false));
        callback && callback({ success: 0, data: null, error });
      }
    );
  };
};

export const deleteActivity = (session, activityId, callback = null) => {
  if (_.isNil(activityId)) return dispatch => {};

  const deleteUrl = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.appuserActivity}/${activityId}`;

  return dispatch => {
    deleteRequest(
      deleteUrl,
      session,
      dispatch,
      res => {
        dispatch(fetchAppuserActivity(session));
        callback && callback({ success: 1, data: res, error: null });
      },
      error => {
        callback && callback({ success: 0, data: null, error });
      }
    );
  };
};

export const addUpdateActivity = (
  session,
  extra = { values: null, activityId: null },
  callback = null
) => {
  if (_.isEmpty(extra?.values)) return dispatch => {};

  const isUpdate = extra?.activityId ?? false;
  const url = `${session.instance_url}${TABLE_URI_ADDON}/${
    TABLES.appuserActivity
  }${isUpdate ? `/${extra?.activityId}` : ''}`;
  const requestPayload = !isUpdate
    ? { resource: [extra?.values] }
    : extra?.values;

  return dispatch => {
    if (!isUpdate) {
      postRequest(
        url,
        requestPayload,
        session,
        dispatch,
        res => {
          showSuccess(LocalStrings.dynamic.kActivityAddedSuccess);
          dispatch(fetchAppuserActivity(session));
          dispatch(setActivityForm({ state: false }));
          callback && callback({ success: 1, data: res, error: null });
        },
        error => {
          showError(LocalStrings.dynamic.kSomethingWentWrongMsg);
          callback && callback({ success: 0, data: null, error });
        }
      );
    } else {
      patchRequest(
        url,
        requestPayload,
        session,
        dispatch,
        res => {
          showSuccess(LocalStrings.dynamic.kActivityAddedSuccess);
          dispatch(fetchAppuserActivity(session));
          callback && callback({ success: 1, data: res, error: null });
        },
        error => {
          showError(LocalStrings.dynamic.kSomethingWentWrongMsg);
          callback && callback({ success: 0, data: null, error });
        }
      );
    }
  };
};

export const setActivityForm = values => {
  return dispatch =>
    dispatch({
      type: ACTIVITY_FORM_RENDER,
      payload:
        _.isEmpty(values) || typeof values !== 'object'
          ? { state: false }
          : values
    });
};
